import React from 'react';

// components
import {Button} from '@mui/joy';
import {CustomModal} from '../CustomModal';

// helpers
import {ConfigManager} from '../../../shared/services/ConfigManager';
import {formatCurrency} from '../../helpers';
import {Trans, useTranslation} from 'react-i18next';

// styles
import {AmountText} from './DeferModal-styles';
import {TextDefault} from '../../styles';

type Props = {
  isOpen: boolean;
  onCloseCallBack: () => void;
  onConfirmCallback: () => void;
};

const DeferModal = ({isOpen, onCloseCallBack, onConfirmCallback}: Props) => {
  const {t} = useTranslation();
  const config = ConfigManager.getConfig();

  const renderActionButtons = () => {
    return (
      <>
        <Button size="lg" onClick={onConfirmCallback}>
          {t('confirm')}
        </Button>
        <Button size="lg" variant="outlined" onClick={onCloseCallBack}>
          {t('global_cancel')}
        </Button>
      </>
    );
  };

  return (
    <CustomModal
      isOpen={isOpen}
      title={t('modal_confirmPaymentDeferral')}
      actionButtons={renderActionButtons()}>
      <TextDefault>
        <Trans
          i18nKey="modal_confirmPaymentDeferralMessage_pt1"
          components={{
            amount: (
              <AmountText>
                {config?.deferralFee
                  ? formatCurrency(config?.deferralFee)
                  : '$ xx'}
              </AmountText>
            ),
          }}
        />
      </TextDefault>
      <TextDefault>{t('modal_confirmPaymentDeferralMessage_pt2')}</TextDefault>
    </CustomModal>
  );
};

export default DeferModal;
